(function($) {
  var $ = jQuery = $;

  window.b2b = new function() {

    var _ = this;
    _.class = "b2b";
    _.key_exclusions = [9,16,17,18,20,27,33,34,35,36,37,38,39,40,45,92];

    //Initialisation
    _.init = function() {
      _.createEventHandlers();
      _.data.validate("init_after_data");
      _.grid.initialise("init_after_pagination"); //Call for accounts page (pagination)
      const urlParams = new URLSearchParams(window.location.search);
      const start_tab = urlParams.get('tab');
      if(start_tab&&start_tab!="") $(".main-navigation [data-connect='"+start_tab+"']").trigger("click");
      _.acknowledge("initialisation complete");
    }

    _.init_after_pagination = function() {
      _.catalogue.init();
      _.orders.prepreload();
    }
    _.init_after_data = function() {
      _.price_points.init(); //MUST COME FIRST, as it controls setting a default price point if one hasn't yet been selected
      _.items.set_prices();
      _.order.set_prices();
      _.cart.set_prices();
      _.addresses.set_form();
      _.marketing.init();
      _.dashboard.set_locks();
      _.pricing_grid.init();
      _.discounts.init();
      _.customer.init(); //Sets general page options based on customer type (ie allowing orders, etc)
      _.order.set_pricepoints_info(); //Sets pricepoints recommendations
      _.orders.history.init(); //Set payment information and options on past orders (based on DMA data from Stripe)
    }
    _.init_no_data = function() {
      _.items.set_prices();
    }

    _.customer = new function() {
      var __ = this;
      __.address_hashes = {shipping:false,billing:false};
      __.init = function() {
        if(window.sessionStorage.hasOwnProperty("b2b_info")) {
          var j_data = JSON.parse(window.sessionStorage.b2b_info);
          var direct_buyer = j_data.customer.direct_buyer;
          if(direct_buyer=="1"){
            console.log("Confirmed direct buyer");
            $(".main-navigation").find("[data-connect='order'],[data-connect='details'],[data-connect='pricing']").closest("li").removeClass("hidden");
            $("#dashboard .accounts-content--section.locked").removeClass("locked");

            //Prepopulate address blocks
            if(j_data.hasOwnProperty("addresses")&&j_data.addresses.length>0) {
              for(a=0;a<j_data.addresses.length;a++){
                var address = j_data.addresses[a];
                $address_block = $("[data-source='address_type:"+address.address_type+"']");
                if($address_block.length>0) {
                  for(const property in address) {
                    $address_block.find("[name='"+property+"']").val(address[property]);
                  }
                }
                __.address_hashes[address.address_type] = _.addresses.hash(address.address_type); //Store hash of the created address
              }
            }
          } else {
            console.log("Customer is not buyer, but can acquire marketing items");
            $(".main-navigation").find("[data-connect='order']").closest("li").removeClass("hidden");
            $("[data-product-button]").remove();
            $("#dashboard .accounts-content--section.locked").remove();
          }
        } else {
          console.log("No local data found");
        }
      }
    }

    _.createEventHandlers = function() {
      _.acknowledge("Assigning event handlers");
      $("body").on("click","[data-b2b-action]",function(e){
        var $element = $(e.currentTarget);
        var actions = $element.attr("data-b2b-action").split(".");
        if(actions.length==1) {
          _.acknowledge("request to call _.b2b_action."+actions[0]);
          _.b2b_action[actions[0]]($element);
        } else if(actions.length==2) {
          _[actions[0]][actions[1]]($element);
        }
        return false;
      }).on("change keyup","[data-b2b-change-action]",function(e){
        if(e.type!="keyup"||_.key_exclusions.indexOf(e.keyCode)==-1) {
          var $element = $(e.currentTarget);
          var actions = $element.attr("data-b2b-change-action").split(".");
          console.log($element.attr("data-b2b-change-action"));
          if(actions.length==1) {
            _.acknowledge("request to call _.b2b_action."+actions[0]);
            _.b2b_action[actions[0]]($element);
          } else if(actions.length==2) {
            _[actions[0]][actions[1]]($element);
          }
        }
      });
    }

    _.dashboard = new function() {
      var __ = this;
      __.set_locks = function(){
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        var direct_buyer = j_data.customer.direct_buyer;
        if(direct_buyer=="1"){
          $(".variable-link--loading").each(function(){
            var $manifest = $($(this).find("[data-variable-state='unlocked']").text());
            $(this).replaceWith($manifest);
          });
        } else {
          $(".variable-link--loading").each(function(){
            var $manifest = $($(this).find("[data-variable-state='locked']").text());
            $(this).replaceWith($manifest);
          });
          // $("#call_to_upgrade").removeClass("hidden");
        }
      }
    }

    _.history = new function() {
      var __ = this;
      __.view = function($element){
        var $order = $element.closest(".order-history--item");
        var $modal = $("#gp-modal");
        $("#gp-modal--contents").html("");

        $gp_content = $("<div class='order-inliner' />");

        $gp_content.append("<h2>Order "+$order.find(".order-history--name").text()+"</h2><p>This order includes the following items:</p>");
        $content = $order.find(".order-history--order-items").clone();
        $content.removeClass("hidden");
        $gp_content.append($content);
        $gp_content.append("<p><a href='#' class='button' data-b2b-action='orders.load_previous'>Back</a></p>");
        $("#gp-modal--contents").append($gp_content);
        _.modal.launch();
        
      }
      __.show = function($element) {
        var $order = $element.closest(".order-history--item");
        $order.find(".order-history--order-summary").addClass("hidden");
        $order.find(".order-history--order-items").removeClass("hidden");
      }
      __.load_query = function($element){
        var cart_contents = $("#shopify-section-cart-sidebar .cart-contents--item").length;
        if(cart_contents>0) {
          var $modal = $("#gp-modal");
          $("#gp-modal--contents").html("");
          var $modal_contents = $($("#order_load_replace").text());
          $("#gp-modal--contents").append($modal_contents);
          $("#gp-modal--contents").append($element.closest(".order-history--item").find("[name='order_contents']").clone());
          _.modal.launch();
        } else {
          __.load($element.closest(".order-history--item").find("[name='order_contents']").val());
        }
      }
      __.load_confirm = function($element){
        var package = $("#gp-modal--contents").find("[name='order_contents']").val();
        $element.addClass("working");
        $element.text("Fetching order ...");
        __.clear(package);
      }
      __.clear = function(load_package) {
        //Clear cart
        var cart_contents = $("#shopify-section-cart-sidebar .cart-contents--item").length;
        var t_data = {};
        if(cart_contents>0) { $.post(window.Shopify.routes.root+"cart/clear.js",t_data,function(data){__.load(load_package);}); }
      }
      __.load = function(load_package){
        //Load cart
        var package = JSON.parse(load_package);
        var items = [];
        for(i=0;i<package.items.length;i++){
          var item = {
            id:package.items[i].id,
            quantity:package.items[i].quantity
          }
          items.push(item);
        }
        if(items.length>0) {
          var t_data = {items:items};
          console.log(t_data);
          console.log(JSON.stringify(t_data));
          $.post(window.Shopify.routes.root+"cart/add.js",t_data,function(data){
            console.log(data);
            _.order.refresh();
            _.modal.close();
            $("body,html").animate({"scrollTop":$("#top-of-order").offset().top-200},150);
          });
        } else {
          _.modal.close();
        }
      }
      __.stop = function($element){
        _.modal.close();
      }
    }

    
    _.addresses = new function() {
      var __ = this;
      __.set_shipping = function($element) {
        var $form = $("#shipping_address");
        var customer_id = $("#customer_id").val();
        if($form.find("[name='address_line_1']").val()==""||$form.find("[name='city']").val()==""||$form.find("[name='postal_code']").val()==""){
          if($form.find("[name='address_line_1']").val()=="") $form.find("[name='address_line_1']").closest("div").addClass("simple-error");
          if($form.find("[name='city']").val()=="") $form.find("[name='city']").closest("div").addClass("simple-error");
          if($form.find("[name='postal_code']").val()=="") $form.find("[name='postal_code']").closest("div").addClass("simple-error");
        } else {
          var t_data = {
            customer_id:customer_id,
            contact_name:$form.find("[name='contact_name']").val(),
            address_line_1:$form.find("[name='address_line_1']").val(),
            address_line_2:$form.find("[name='address_line_2']").val(),
            city:$form.find("[name='city']").val(),
            state:$form.find("[name='state']").val(),
            postal_code:$form.find("[name='postal_code']").val()
          }
          console.log(t_data);
          $element.addClass("working");
          
          $.post("https://accounts.togetherhealth.co.uk/w/addresses/"+customer_id+"/createShipping/",t_data,function(data){
            console.log(data);
            $element.removeClass("working");
            var $form = $("#shipping_address");
            //Put the form back in storage (auto-includes any user updates)
            $("#shipping_address_placer").append($form);
            $("#gp-modal--contents").html($("#order_processing").text());
            _.orders.place();
          });
        }
      }
      __.set_form = function() {
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        for(var a=0;a<j_data.addresses.length;a++) {
          var address = j_data.addresses[a];
          var $form = $("#shipping_address");
          if(typeof(address)!="undefined"&&address.address_type=='shipping') {
            $form.find("[name='contact_name']").val(address.contact_name);
            $form.find("[name='address_line_1']").val(address.address_line_1);
            $form.find("[name='address_line_2']").val(address.address_line_2);
            $form.find("[name='city']").val(address.city);
            $form.find("[name='state']").val(address.state);
            $form.find("[name='postal_code']").val(address.postal_code);
          }
        }
      }
      __.hash = function(address_type) {
        const $address_block = $("[data-source='address_type:"+address_type+"']");
        var hashBlob = "";
        if($address_block.length>0) {
          $address_block.find("input").each(function(){
            if($(this).val()!="") hashBlob += $(this).val();
          });
        }
        return _.hashCode(hashBlob);
      }
      __.monitor = function($element) {
        const $address_block = $element.closest("[data-source]");
        const address_type = $address_block.attr("data-source").split(":")[1];
        const new_hash = __.hash(address_type);
        //Clear any response messages
        $address_block.find("[data-action-response-positive],[data-action-response-negative]").addClass("hidden");
        if(new_hash==_.customer.address_hashes[address_type]) {
          //Address has not changed
          $address_block.find("[data-action-prompt]").addClass("hidden");
        } else {
          //Changes need to be saved
          $address_block.find("[data-action-prompt]").removeClass("hidden");
        }
          

      }
    }

    _.items = new function() {
      //Object handles presetting values on product pages according to available items from DMA Wholesale app
      var __ = this;
      __.set_prices = function() {
        if(window.sessionStorage.hasOwnProperty("b2b_info")) {
          var j_data = JSON.parse(window.sessionStorage.b2b_info);
          if(j_data.customer.status=="1") {
            
            if($(".section-product-block").attr("data-product-type")=="case"||$(".section-product-block").attr("data-product-type")=="pack") {
              if(j_data.customer.direct_buyer=="1") {
                // console.log("Customer is direct buyer");
                var product_available = true;
                for(var i=0;i<j_data.items.length;i++) {
                  var item = j_data.items[i];
                  if(item.hasOwnProperty("available")&&item.available==0) {
                    product_available = false;
                  } else {
                    for(var id=0;id<item.identities.length;id++) {
                      var identity = item.identities[id];
                      if(identity.system=="shopify") {
                        // console.log("Found Shopify identity ("+identity.id+")");
                        var $purchase_option = $(".purchase--option[data-product-id='"+identity.id+"']");
                        if($purchase_option.length>0){
                          // var best_price = (item.hasOwnProperty("customer_base_price")?item.customer_base_price:item.base_price); //OLD
                          var best_price = _.product.pricepoint_price(item,j_data.customer.default_pricepoint_id);
                          $purchase_option.attr("data-unit-price",best_price);
                          $purchase_option.find(".purchase--money").text(_.format.money(best_price));
                          var sku_parts = item.sku.split("-");
                          var last_sku_part = sku_parts[sku_parts.length-1];
                          if(last_sku_part=="5"||last_sku_part=="6") $purchase_option.find("#per_case").text(last_sku_part);
          
                          $purchase_option.find("[name='quantity']").attr("value",1);
                          
                          $purchase_option.removeClass("hidden");
                          $purchase_option.find("[name='quantity']").trigger("change");
                          // console.log("Found purchase option");
                        }
                      }
                    }
                  }
                }
                $(".purchase--preload").addClass("hidden");
                if(product_available) {
                  $(".purchase--option--labels,.purchase--action").removeClass("hidden");
                  if(j_data.hasOwnProperty("requirements")) {
                    $("#order_requirement").text("£"+parseInt(j_data.requirements.amount));
                    $(".purchase--info").removeClass("hidden");
                  }
                } else {
                  $("#pp-product-form .purchase--preload").after("<p style='text-align:center'>This product is currently out of stock</p>");
                }

              } else {
                $(".purchase--action").html("<p style='text-align:center;'><a href='/account/'>Upgrade your account</a> to buy from us directly!</p>");
                $(".purchase--preload").addClass("hidden");
                $(".purchase--action").removeClass("hidden");
              }
            } else {
              //Marketing product
              var $purchase_option = $(".purchase--option[data-product-id]").eq(0);
              $purchase_option.attr("data-unit-price",0);
              $purchase_option.find(".purchase--money").text("£"+0);
              $purchase_option.find("[name='quantity']").attr("value",1);
              $purchase_option.removeClass("hidden");
              $purchase_option.find("[name='quantity']").trigger("change");
              $(".purchase--option--labels,.purchase--action").removeClass("hidden");
              $(".purchase--preload").addClass("hidden");
              // console.log("Found marketing option");
            }


            
          } else {
            $(".purchase--action").html("<p style='text-align:center;'>Your account is currently pending approval</p>");
            $(".purchase--preload").addClass("hidden");
            $(".purchase--action").removeClass("hidden");
          }
        } else {
          $(".purchase--action").html("<p style='text-align:center;'>You are not currently logged in</p>");
          $(".purchase--preload").addClass("hidden");
          $(".purchase--action").removeClass("hidden");
        }
      }
      __.quantities = function($element) {
        var total_items = 0;
        var total_price = 0;
        $(".purchases--grid [data-product-id]:visible").each(function(){
          var quantity = parseInt($(this).find("[name='quantity']").val());
          total_items += quantity;
          total_price += $(this).attr("data-unit-price")*quantity;
        });
        var $button = $("button[data-b2b-action='items.add_to_cart']");
        // console.log("This is the total of items selected: "+total_items);
        if(total_items>0){
          $button.removeClass("disabled");
          $button.find(".order_price").removeClass("hidden");
          $button.find(".order_price").text("£"+total_price.toFixed(2)+" | ");
        } else {
          $button.addClass("disabled");
          $button.find(".order_price").addClass("hidden");
        }
      }
      __.add_to_cart = function($element) {
        $element.addClass("working");
        var items = [];
        $(".purchases--grid [data-product-id]:visible").each(function(){
          var quantity = $(this).find("[name='quantity']").val();
          if(quantity>0){
            var item = {
              id:$(this).attr("data-variant-id"),
              quantity:quantity
            }
            items.push(item);
          }
        });
        if(items.length>0) {
          var t_data = {items:items};
          // console.log(t_data);
          $.post(window.Shopify.routes.root+"cart/add.js",t_data,function(data){
            // console.log(data);
            main.sidebarCart.update(true); //Call extant (external) function to refresh cart and show it
            $element.removeClass("working");
          });
        }
      }
    }

    _.grid = new function() {
      var __ = this;
      __.initialise = function(callback) {
        //Main controller function to complete grid load (pagination) then initialise according to data
        //Check if grid exists
        if($(".purchase-grid").length>0) {
          //Check if user is on accounts page
          if(window.location.href.indexOf("account")>-1) {
            // console.log("needs pagination request");
            $.get(window.location.href.split("#")[0].split("?")[0]+"?page=2&view=blank",function(data){
              // console.log("Page 2 loaded");
              var $data = $(data);
              $(".purchase-grid--grid").append($data.find(".purchase-grid--grid").find(".purchase-grid--item-background,script"));
              $.get(window.location.href.split("#")[0].split("?")[0]+"?page=3&view=blank",function(data){
                // console.log("Page 3 loaded");
                var $data = $(data);
                $(".purchase-grid--grid").append($data.find(".purchase-grid--grid").find(".purchase-grid--item-background,script"));
                //Now check the offsite data is present and continue to redacting the grid list accordingly
                _.data.validate("grid.validate");
                __.show_cart_contents();
                _.callback(callback);
              });
            });
          }
        }
      }
      __.show_cart_contents = function() {
        // console.log(cart_contents);
        $(".purchase-grid--product .exists-in-cart").removeClass(".exists-in-cart");
        $(".purchase-grid--product .quantity-in-cart").addClass("hidden");
        $(".purchase-grid--product").find(".button").addClass("btn").removeClass("button");
        for(i=0;i<cart_contents.items.length;i++){
          var item = cart_contents.items[i];
          var $product_grid_item = $(".purchase-grid--product[data-variant-id='"+item.variant_id+"']");
          var $product_grid_item_action = $product_grid_item.find(".purchase-grid--product--action");
          $product_grid_item_action.addClass(".exists-in-cart");
          $product_grid_item_action.find(".btn").addClass("button").removeClass("btn");
          $product_grid_item_action.find(".quantity-in-cart").text(item.quantity+" in cart");
          $product_grid_item_action.find(".quantity-in-cart").removeClass("hidden");
        }
      }
      __.validate = function() {
        //Validates items loaded into the generic product grid and removes elements not on the user's account
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        var is_buyer = j_data.customer.direct_buyer==1?true:false;
        // console.log("is_buyer: "+is_buyer);
        $(".purchase-grid--product").each(function(){
          var $product = $(this);
          var product_exists = false;
          for(var i=0;i<j_data.items.length;i++){
            var item = j_data.items[i];
            if(!item.hasOwnProperty("available")||item.available==1) {
              for(var id=0;id<item.identities.length;id++) {
                var identity = item.identities[id];
                if(identity.system=="shopify"&&identity.id==$product.attr("data-product-id")) {
                  product_exists = true;
                  // var best_price = (item.hasOwnProperty("customer_base_price")?item.customer_base_price:item.base_price); //OLD
                  var best_price = _.product.pricepoint_price(item,j_data.customer.default_pricepoint_id);

                  //Item RRP in grid
                  $product.find(".purchase-grid--product--discount [data-item-rrp]").text("£"+item.retail_price);

                  //Item price in grid
                  $product.find(".purchase-grid--product--unit-price [data-item-price]").text("£"+best_price.toFixed(2));

                  //Line total in grid
                  var quantity = $product.find("[name='quantity']").val();
                  $product.find(".purchase-grid--product--total-price [data-item-price]").text("£"+(quantity*best_price.toFixed(2)).toFixed(2));
                  
                  $product.attr("data-product-unit-price",best_price);

                  //Purchase limits (quantity limits)
                  if(item.hasOwnProperty("limit_quantity")) {
                    console.log(item.title+" has order limits");
                    //Set text on product title
                    var $item_link = $product.find(".purchase-grid--product--title a");
                    var $link_wrapper = $("<span></span>");
                    $link_wrapper.append($("<span class='purchase-grid--order-limit'>*Max "+item.limit_quantity+" per "+item.limit_amount+" "+item.limit_unit+"s</span>"));
                    $item_link.after($link_wrapper);
                    $link_wrapper.prepend($item_link);
                    //Set max constraint on input box
                    $product.find("[name='quantity']").attr("max",item.limit_quantity-item.limit_quantity_ordered);
                  }
                }
              }
            }
          }
          if(!product_exists&&$product.attr("data-product-type")!="marketing"&&$product.attr("data-product-type")!="training") {
            //Previously, this option would simply remove the item, now we have to keep it in the grid, fake the pricing (except cases, which still get removed)
            if(is_buyer||$product.attr("data-product-type")=="case") {
              $product.closest(".purchase-grid--item-background").remove();
            } else {
              var sim_pricepoint = (100-j_data.pricepoints[0].discount_amount)/100;
              //Item RRP in grid
              $product.find(".purchase-grid--product--discount [data-item-rrp]").text(_.format.money($product.attr("data-product-rrp")/100));
              //Item price in grid
              $product.find(".purchase-grid--product--unit-price [data-item-price]").text(_.format.money($product.attr("data-product-unit-price")/100));//*sim_pricepoint
              //Line total in grid
              $product.find(".purchase-grid--product--total-price [data-item-price]").text(_.format.money($product.attr("data-product-unit-price")/100));//*sim_pricepoint
              //Disable actions
              $product.find("[data-b2b-action]").removeAttr("data-b2b-action");
              $product.find("[data-b2b-change-action]").removeAttr("data-b2b-change-action");
            }
          }
        });
        if($(".purchase-grid--product").length==0) {
          $(".purchase-grid--failed").removeClass("hidden");
        } else {
          $(".purchase-grid").removeClass("hidden");
          $(".purchase-grid--filter").removeClass("hidden");
        }
        $(".purchase-grid--loading").addClass("hidden");
      }
      __.add_to_cart = function($element) {
        __.lockdown();
        // console.log("add_to_cart");
        var items = [];
        $(".purchase-grid [data-product-id]:visible").each(function(){
          var quantity = $(this).find("[name='quantity']").val();
          if(quantity>0){
            // console.log("adding item "+$(this).attr("data-variant-id"));
            var item = {
              id:$(this).attr("data-variant-id"),
              quantity:quantity
            }
            items.push(item);
          }
        });
        if(items.length>0) {
          var t_data = {items:items};
          // console.log(t_data);
          $.post(window.Shopify.routes.root+"cart/add.js",t_data,function(data){
            // console.log(data);
            main.sidebarCart.update(true); //Call extant (external) function to refresh cart and show it
            __.unlock();
          });
        } else {
          alert("Nothing to add!");
          __.unlock();
        }
      }
      __.add_to_order = function($element) {
        var $wrapper = $element.closest(".purchase-grid--product--action");

        var $product = $element.closest(".purchase-grid--product");
        var new_product_block = $("#blank-product-grid").text();
        var sku = $product.attr("data-product-sku");
        var quantity = $product.find("[name='quantity']").val();
        if(quantity>0) {

          var items = [];
          var item = {
            id:$product.attr("data-variant-id"),
            quantity:quantity
          }
          items.push(item);
          
          if(items.length>0) {
            $element.addClass("working");
            var t_data = {items:items};
            // console.log(t_data);
            // console.log(JSON.stringify(t_data));
            $.post(window.Shopify.routes.root+"cart/add.js",t_data,function(data){
              // console.log(data);
              main.sidebarCart.update(false); //Call extant (external) function to refresh cart and suppress it

              var item_price = parseFloat($product.attr("data-product-unit-price"));
              var cost_in_pence = Math.round((item_price*100)*quantity);
              new_product_block = new_product_block
                                  .replace("product.description",$product.find(".purchase-grid--product--title").text()+" "+$product.attr("data-product-type").replace("pack","single"))
                                  .replace("product.sku",sku)
                                  .replace("product.pack_size",$product.find(".purchase-grid--product--pack-size").text())
                                  .replace("product.quantity",quantity)
                                  .replace("product.discount","0")
                                  .replace("product.price","£"+item_price.toFixed(2))
                                  .replace("product.total","£"+(cost_in_pence/100).toFixed(2))
              
              $new_product_block = $(new_product_block);
              $(".order-grid--grid").append($new_product_block);
                
              $wrapper.find(".adding-complete").removeClass("hidden");
              $element.removeClass("working");
              setTimeout(function(){
                $wrapper.find(".adding-complete").animate({"opacity":0},function(){
                  $wrapper.find(".adding-complete").addClass("hidden");
                  $wrapper.find(".adding-complete").css({"opacity":1});
                });
              },1000);

              _.order.refresh();

            });
          }
          
        }
        
      }
      __.pricing = function() {
        //Update all list pricing based on selected quantity x attribute-stored unit pricing
        $(".purchase-grid .purchase-grid--product").each(function(){
          var $product = $(this);
          var quantity = $product.find("[name='quantity']").val();
          var item_price = $product.attr("data-product-unit-price");
          var cost_in_pence = Math.round((item_price*100)*quantity);
          $product.find(".purchase-grid--product--total-price [data-item-price]").text("£"+(cost_in_pence/100).toFixed(2));
        });
        
      }
      __.lockdown = function() {
        $(".purchase-actions .btn").addClass("working");
        $(".purchase-grid").addClass("working");
      }
      __.unlock = function() {
        $(".purchase-actions .btn").removeClass("working");
        $(".purchase-grid").removeClass("working");
      }
    }

    _.catalogue = new function() {
      var __ = this;
      __.init = function() {
        //Two reasons for this: 1/ If the user has no products allowed, the tabs don't make sense; 2/ It's easier to prime the matching options from a dedicated module
        //Above notes redacted as we need to force the products to be visible even if the customer can't buy them
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        var has_products = false; //Presume free-only account
        var item = undefined;
        for(i=0;i<j_data.items.length;i++){
          item = j_data.items[i];
          if(item.type=="pack"||item.type=="case") has_products = true;
        }
        if(has_products){
          $(".purchase-grid--item-background").removeClass("hidden");
          $(".purchase-grid--product[data-product-type='marketing'],.purchase-grid--product[data-product-type='training']").closest(".purchase-grid--item-background").addClass("hidden");
          // $("#intro_products").removeClass("hidden");
        } else {
          //Customer has no permissions
          // $(".purchase-grid--filter").remove(); //This element has visibility controls elsewhere
          $(".purchase-grid--product[data-product-type='case'],.purchase-grid--product[data-product-type='marketing'],.purchase-grid--product[data-product-type='training']").closest(".purchase-grid--item-background").addClass("hidden");
          $("[data-filter-type='cases']").closest("li").remove();
          //Set "simulation mode" on all grid elements
          $(".purchase-grid").addClass("purchase-grid--simulation");
          $("[data-b2b-action='catalogue.filter'][data-filter-type='products']").attr("data-simulation","");
          //Redact the search function
          $(".purchase-grid--search").remove();
          // $("#intro_marketing").removeClass("hidden");
        }
        
      }
      __.filter = function($element) {
        var $filter = $element.closest(".purchase-grid--filter");
        $filter.find("[data-active]").removeAttr("data-active");
        $element.attr("data-active","");

        var selected_type = $element.attr("data-filter-type");
        $(".purchase-grid--item-background").removeClass("hidden");
        if(selected_type=="products"){
          $(".purchase-grid--product[data-product-type='marketing'],.purchase-grid--product[data-product-type='training']").closest(".purchase-grid--item-background").addClass("hidden");
          if($element.is("[data-simulation]")) $(".purchase-grid").addClass("purchase-grid--simulation");
          $(".purchase-grid--sub-filter").removeClass("hidden");
        } else if(selected_type=="cases"){
          $(".purchase-grid--product[data-product-type='pack'],.purchase-grid--product[data-product-type='marketing'],.purchase-grid--product[data-product-type='training']").closest(".purchase-grid--item-background").addClass("hidden");
          $(".purchase-grid").removeClass("purchase-grid--simulation");
          $(".purchase-grid--sub-filter").removeClass("hidden");
        } else if(selected_type=="marketing"){
          $(".purchase-grid--product[data-product-type='pack'],.purchase-grid--product[data-product-type='case']").closest(".purchase-grid--item-background").addClass("hidden");
          $(".purchase-grid--product[data-product-type='training']").closest(".purchase-grid--item-background").addClass("hidden");
          $(".purchase-grid").removeClass("purchase-grid--simulation");
          $(".purchase-grid--sub-filter").addClass("hidden");
        } else if(selected_type=="training"){
          $(".purchase-grid--product[data-product-type='pack'],.purchase-grid--product[data-product-type='case']").closest(".purchase-grid--item-background").addClass("hidden");
          $(".purchase-grid--product[data-product-type='marketing']").closest(".purchase-grid--item-background").addClass("hidden");
          $(".purchase-grid").removeClass("purchase-grid--simulation");
          $(".purchase-grid--sub-filter").addClass("hidden");
        }
      }
      __.subfilter = function($element) {
        //This function ONLY manages the 'selected' state of the OS component, the values are incorporated into the search refresh, which is triggered at the end
        var selected_subtype = $element.attr("data-filter-subtype");
        if($element.is("[data-checked='true']")) {
          //!!DO NOT turn off if only selected option! (This may make for really weird UX)
          if($("[data-filter-subtype][data-checked='true']").length>1) $element.attr("data-checked","false");
        } else {
          $element.attr("data-checked","true");
        }
        __.search($(".purchase-grid--search [name='catalogue_search']"));
      }
      __.search = function($element) {
        var search_term = $element.val().toLowerCase();
        var search_types = [];
        $(".sub-filter").each(function(){
          if($(this).is("[data-checked='true']")){
            search_types.push($(this).attr("data-filter-subtype"));
          }
        });
        
        if(search_term!="") {
          $(".purchase-grid--search--clear").removeClass("hidden");
          console.log(search_types);
          $(".purchase-grid--item-background").each(function(){
            var myType = $(this).find("[data-product-type]").attr("data-product-type");
            if($(this).find("[data-product-search]").text().indexOf(search_term)==-1||search_types.indexOf(myType)==-1){
              $(this).attr("data-search-result","no-match");
            } else {
              $(this).removeAttr("data-search-result");
            }
          });
        } else {
          console.log(search_types);
          $(".purchase-grid--search--clear").addClass("hidden");
          $(".purchase-grid--item-background").removeAttr("data-search-result");
          $(".purchase-grid--item-background").each(function(){
            var myType = $(this).find("[data-product-type]").attr("data-product-type");
            if(search_types.indexOf(myType)==-1&&(myType=="pack"||myType=="case")){
              $(this).attr("data-search-result","no-match");
            } else {
              $(this).removeAttr("data-search-result");
            }
          });
        }
      }
      __.clear_search = function($element) {
        $(".purchase-grid--search--clear").addClass("hidden");
        $("[name='catalogue_search']").val("");
        $(".purchase-grid--item-background").removeAttr("data-search-result");
      }
    }

    _.pricing_grid = new function() {
      var __ = this;
      __.init = function() {
        // console.log("pricing_grid.init");
        __.page();
      }
      __.page = function() {
        // console.log("pricing_grid.init");
        $.get("/account?page=2",function(data){
          var $data = $(data);
          $("#pricing .pricing-grid--grid").append($data.find(".pricing-grid--grid .pricing-grid--item-background"));
          __.validate();
        });
      }
      __.validate = function() {
        // console.log("pricing_grid.validate");
        //Validates items loaded into the generic product grid and removes elements not on the user's account
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        $(".pricing-grid--product").each(function(){
          var $product = $(this);
          var product_exists = false;
          for(var i=0;i<j_data.items.length;i++){
            var item = j_data.items[i];
            for(var id=0;id<item.identities.length;id++) {
              var identity = item.identities[id];
              if(identity.system=="shopify"&&identity.id==$product.attr("data-product-id")) {
                product_exists = true;
                // var best_price = (item.hasOwnProperty("customer_base_price")?item.customer_base_price:item.base_price); //OLD
                var best_price = _.product.pricepoint_price(item,j_data.customer.default_pricepoint_id);

                //Item RRP in grid
                $product.find(".pricing-grid--product--discount [data-item-rrp]").text("£"+item.retail_price);

                //Item RRP-ex-VAT in grid
                $product.find(".pricing-grid--product--unit-price [data-item-rrp-ex-vat]").text("£"+(item.retail_price/1.2).toFixed(2));

                //Margin in grid
                $product.find(".pricing-grid--product--margin [data-item-margin]").text(_.price_points.current().discount_amount+"%");
                
                //Line total in grid
                $product.find(".pricing-grid--product--total-price [data-item-price]").text("£"+best_price.toFixed(2));
                
                $product.attr("data-product-unit-price",best_price);
              }
            }
          }
          if(!product_exists) $product.closest(".pricing-grid--item-background").remove(); //Do not exclude marketing items, they need to go if present! (suppressed in render loop, bu jic)
        });
        if($(".pricing-grid--product").length==0) {
          $(".pricing-grid--failed").removeClass("hidden");
        } else {
          $(".pricing-grid").removeClass("hidden");
        }
        $(".pricing-grid--loading").addClass("hidden");
      }      
    }

    _.price_points = new function() {
      var __ = this;
      __.init = function() {
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        // !!Check a default pricepoint is found and, if not, set one!
        if(j_data.customer.default_pricepoint_id==null) {
          // console.log("Missing default pricepoint");
          j_data.customer.default_pricepoint_id = j_data.pricepoints[0].pricepoint_id;
          _.data.store(JSON.stringify(j_data));
        }
        $("#tier_selector").html("");
        for(var p=0;p<j_data.pricepoints.length;p++){
          var pricepoint = j_data.pricepoints[p];
          var $newOption = $("<div class='pricepoint-selector'><a href='#' class='selector-button' data-pricepoint-id='"+pricepoint.pricepoint_id+"' data-b2b-action='price_points.select'></a></div>");
          if(pricepoint.pricepoint_id==j_data.customer.default_pricepoint_id) {
            $newOption.find("a").addClass("active");
          }
          $newOption.find("a").html("<span class='pricepoint-title'>"+pricepoint.title+"</span><span class='pricepoint-divider'></span><span class='pricepoint-detail'><span class='pricepoint-label'>Margin:</span><span class='pricepoint-fact'>"+pricepoint.discount_amount+"%</span></span><span class='pricepoint-detail'><span class='pricepoint-label'>MOV:</span><span class='pricepoint-fact'>£"+pricepoint.limit_amount+"</span></span><span class='pricepoint-select'><span class='button'>Select</span></span>");
          $("#tier_selector").append($newOption);
        }
      }
      __.open_modal = function($element) {
        var $modal = $("#gp_modal");
        $("#gp-modal--contents").html("");
        $("#gp-modal--contents").append($("#pricing-tiers").children());
        $("#gp-modal--contents").append($("<p class='modal-actions'><a href='#' data-b2b-action='modal.close' class='button'>Close</a></p>"));
        _.modal.launch();
        $("#pricing-intro").removeClass("hidden");
        $("#gp_modal .gp-modal--window").addClass("gp-modal--window--wide gp-modal--window--padded");

      }
      __.select = function($element) {
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        var pricepoint_id = $element.attr("data-pricepoint-id");
        j_data.customer.default_pricepoint_id = pricepoint_id;
        _.data.store(JSON.stringify(j_data));
        $("#tier_selector .active").removeClass("active");
        $element.addClass("active");
        //Send async post to update default choice on DMA
        var customer_id = $("#info").attr("data-customer-id");
        var t_data = {customer_id:customer_id,pricepoint_id:pricepoint_id};
        $.post("https://accounts.togetherhealth.co.uk/w/remote/"+customer_id+"/setDefaultPricepoint/",t_data,function(data){console.log(data);});
        //Refresh on-screen prices
        _.items.set_prices();
        _.order.set_prices();
        _.cart.set_prices();
        _.grid.validate();
        _.pricing_grid.validate();
      }
      __.minimum_order_value = function() {
        //Returns the MOV for the customer's selected tier
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        var response = false;
        for(var p=0;p<j_data.pricepoints.length;p++){
          var pricepoint = j_data.pricepoints[p];
          if(pricepoint.pricepoint_id==j_data.customer.default_pricepoint_id) {
            response = parseFloat(pricepoint.limit_amount);
          }
        }
        return response;
      }
      __.current = function() {
        //Returns the full object of the currently selected user pricepoint
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        var response = false;
        if(j_data.hasOwnProperty("pricepoints")) {
          for(var p=0;p<j_data.pricepoints.length;p++){
            var pricepoint = j_data.pricepoints[p];
            if(pricepoint.pricepoint_id==j_data.customer.default_pricepoint_id) {
              response = pricepoint;
            }
          }
        }
        return response;
      }
      __.tiers = new function() {
        var ___ = this;
        ___.product_price = function(pricepoint_id,product_id) {
          //Returns the price of a given product at the given pricepoint id
          //Returns zero if invalid item (ie not on customers account) is given
          var j_data = JSON.parse(window.sessionStorage.b2b_info);
          var response = {base_price:0,pricepoint_price:0};
          if(j_data.hasOwnProperty("pricepoints")&&j_data.hasOwnProperty("items")) {
            var pricepoints = j_data.pricepoints;
            var working_pricepoint = false;
            for(var p=0;p<pricepoints.length;p++){
              if(pricepoints[p].pricepoint_id==pricepoint_id) working_pricepoint = pricepoints[p];
            }
            if(working_pricepoint!==false) {
              var items = j_data.items;
              for(var i=0;i<items.length;i++){
                var item = items[i];
                for(var d=0;d<item.identities.length;d++) {
                  var identity = item.identities[d];
                  if(identity.system=="shopify"&&identity.id==product_id){
                    response = {
                      base_price:parseFloat(item.base_price),
                      pricepoint_price:parseFloat((parseFloat(item.retail_price_ex_vat)*((100-parseFloat(working_pricepoint.discount_amount))/100)).toFixed(2))
                    };
                  }
                }
                
              }
            }
          }
          return response;
        }
      }
      __.optimal = function() {
        //Analyses the current cart at all tier levels to determing the most preferrable to the user
        var proximity_tolerance = 10; //Was pounds, now percent
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        var response = false;
        var calculations = [];
        var best_pricepoint = false;
        var suggested_pricepoint = false;
        if(j_data.hasOwnProperty("pricepoints")&&typeof(cart_contents)!=="undefined") {
          //Find the total at the CURRENT pricepoint
          var current_total = 0;
          var current_pricepoint = __.current();
          for(var c=0;c<cart_contents.items.length;c++){
            var item = cart_contents.items[c];
            current_total += (__.tiers.product_price(current_pricepoint.pricepoint_id,item.product_id).pricepoint_price)*item.quantity;
          }
          var pricepoints = j_data.pricepoints;
          for(var p=0;p<pricepoints.length;p++){
            var pricepoint = pricepoints[p];
            var calculation = {};
            total = 0;
            for(var c=0;c<cart_contents.items.length;c++){
              var item = cart_contents.items[c];
              total += (__.tiers.product_price(pricepoint.pricepoint_id,item.product_id).pricepoint_price)*item.quantity;
            }
            var calculation = {
              title:pricepoint.title,
              pricepoint_id:pricepoint.pricepoint_id,
              total:total,
              minimum_order_value:parseFloat(pricepoint.limit_amount).toFixed(2),
              qualifies:(total>=parseFloat(calculation.minimum_order_value)?true:false)
            };
            if(total>=parseFloat(calculation.minimum_order_value)){
              best_pricepoint = pricepoint;
            }
            //See if the current order is above the currently selected pricepoint's threshold, and within tolerances of the current working pricepoint
            // if(current_total>=parseFloat(current_pricepoint.limit_amount)&&total>=parseFloat(calculation.minimum_order_value)-proximity_tolerance){ //Previous method using p_t as cash value (£)
            if(current_total>=parseFloat(current_pricepoint.limit_amount)&&total>=parseFloat(calculation.minimum_order_value)-((parseFloat(pricepoint.limit_amount)/100)*proximity_tolerance)){
              suggested_pricepoint = pricepoint;
            }
            calculations.push(calculation);
          }
          response = {
            best_pricepoint:best_pricepoint,
            suggested_pricepoint:suggested_pricepoint,
            calculations:calculations
          };
          // console.log(response);
        }
        return response;
      }
    }

    _.cart = new function() {
      var __ = this;
      __.set_prices = function() {
        if(window.sessionStorage.b2b_info) {
          __.set_line_item_prices();
          __.set_total_pricing();
          __.set_order_validation();
        }
      }
      __.set_line_item_prices = function() {
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        var $cart = $("#cart-sidebar-wrapper");
        $cart.find("[data-b2b-product-id]").each(function(){
          var $item = $(this).closest(".cart-contents--item");
          var search_id = $(this).attr("data-b2b-product-id");
          if($item.attr("data-item-type")=="marketing"||$item.attr("data-item-type")=="training"){
            var quantity = $item.find(".cart-item--quantity").text();
            // console.log("Marketing product");
            $(this).text("£0.00");
            $item.attr("data-b2b-line-price",0);
            $(this).removeClass("small-inline--spinner");
            $item.attr("data-total-price",0);
            $item.attr("data-unit-price",0);
            $item.attr("data-line-quantity",quantity);
          } else {
            for(var i=0;i<j_data.items.length;i++){
              var item = j_data.items[i];
              var found_shopify = false;
              for(var id=0;id<item.identities.length;id++) {
                var identity = item.identities[id];
                if(identity.system=="shopify"&&identity.id==search_id) {
                  // var best_price = (item.hasOwnProperty("customer_base_price")?item.customer_base_price:item.base_price); //OLD
                  var best_price = _.product.pricepoint_price(item,j_data.customer.default_pricepoint_id);
                  var quantity = $item.find(".cart-item--quantity").text();
                  $(this).text("£"+(best_price*quantity).toFixed(2));
                  $item.attr("data-b2b-line-price",(best_price*quantity));
                  $(this).removeClass("small-inline--spinner");
                  $item.attr("data-total-price",(best_price*quantity)*100);
                  $item.attr("data-unit-price",best_price*100);
                  $item.attr("data-line-quantity",quantity);
                  found_shopify = true;
                }
              }
              if(found_shopify) {
                //Expose the Stripe ID
                for(var id=0;id<item.identities.length;id++) {
                  var identity = item.identities[id];
                  if(identity.system=="stripe") {
                    $item.attr("data-external-id",identity.id);
                  }
                }
              }
            }
          }
        });
      }
      __.set_total_pricing = function() {
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        var $cart = $("#cart-sidebar-wrapper");
        var total_price = 0;
        $cart.find(".cart-contents--item").each(function(){
          total_price += parseFloat($(this).attr("data-b2b-line-price"));
        });
        $("#sidebar-cart--total").html("£"+total_price.toFixed(2)+"<span style='color:var(--theme-colour--border);font-size:70%;'> + VAT</span>");
      }
      __.set_order_validation = function() {
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        if(j_data.hasOwnProperty("requirements")) {
          var $cart = $("#cart-sidebar-wrapper");
          var total_price = parseFloat($("#sidebar-cart--total").text().replace("£",""));
          var progress = Math.min((total_price/j_data.requirements.amount)*100,100);
          // console.log(total_price+"/"+j_data.requirements.amount);
          $(".cart-sidebar--free-shipping-chart-progress-bar").css({"width":progress+"%"});
          // console.log("progress: "+progress);
          if(progress==100) {
            $cart.find(".cart-sidebar--free-shipping > p:first-child").text("ORDER CAN BE PLACED");
            $cart.find("[name='checkout']").removeClass("disabled");
          } else {
            $cart.find(".cart-sidebar--free-shipping > p:first-child").text("ORDER VALUE MUST BE AT LEAST £"+j_data.requirements.amount);
            $cart.find("[name='checkout']").addClass("disabled");
          }
        }
      }
    }

    _.order = new function() {
      var __ = this;
      __.update_timer = undefined;
      __.set_prices = function() {
        //Initialises object-based pricing on the cart order element (account page, currently)
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        var order_total = 0;
        $(".order-grid--item-grid[data-product-id]").each(function(){
          var $item = $(this);
          var item_exists = false;
          for(var i=0;i<j_data.items.length;i++){
            var item = j_data.items[i];
            for(var id=0;id<item.identities.length;id++) {
              var identity = item.identities[id];
              if(identity.system=="shopify"&&identity.id==$item.attr("data-product-id")) {
                item_exists = true;
                // var best_price = parseFloat(item.hasOwnProperty("customer_base_price")?item.customer_base_price:item.base_price); //OLD

                //Item RRP in grid
                $item.find("[data-item-rrp]").text(_.format.money(item.retail_price));
                
                var best_price = _.product.pricepoint_price(item,j_data.customer.default_pricepoint_id);
                $item.find("[data-item-price]").text(_.format.money(best_price));
                $item.attr("data-product-unit-price",best_price);
                var quantity = $item.find("[name='quantity']").val();
                var line_total = (((best_price*100)*quantity)/100);
                $item.find("[data-item-price-total]").text(_.format.money(line_total));
                // console.log("order_total: "+order_total+" + "+line_total.toFixed(2));
                order_total += parseFloat(line_total.toFixed(2));

                //Purchase limits (quantity limits)
                if(item.hasOwnProperty("limit_quantity")) {
                  console.log(item.title+" in order builder has order limits");
                  //Set text on product title
                  var $item_link = $item.find(".order-grid--title a");
                  var $link_wrapper = $("<span></span>");
                  $link_wrapper.append($("<span class='order-grid--order-limit'>*Max "+item.limit_quantity+" per "+item.limit_amount+" "+item.limit_unit+"s</span>"));
                  $item_link.after($link_wrapper);
                  $link_wrapper.prepend($item_link);
                  //Set max constraint on input box
                  $item.find("[name='quantity']").attr("max",item.limit_quantity-item.limit_quantity_ordered);
                }
                
              }
            }
          }
          if(!item_exists&&!$item.is("[data-item-marketing]")) $item.closest(".order-grid--item-background").remove();
        });
        // console.log("final order_total: "+order_total);
        __.set_totals(order_total);
        // if($(".purchase-grid--product").length==0) {
        //   $(".purchase-grid--failed").removeClass("hidden");
        // } else {
        //   $(".purchase-grid").removeClass("hidden");
        //   $(".purchase-grid--filter").removeClass("hidden");
        // }
        // $(".purchase-grid--loading").addClass("hidden");
      }
      __.set_totals = function(order_total) {
        // $(".order-grid").addClass("order-grid--refreshing");
        var ex_vat = parseFloat(order_total).toFixed(2);
        var discount_amount = 0;
        if(_.discounts.exist()) {
          var discount_percent = _.discounts.percent();
          discount_amount = (ex_vat/100)*discount_percent;
        }
        var total = (parseFloat(order_total-discount_amount)*1.2).toFixed(2);
        var vat = (parseFloat(order_total-discount_amount)*0.2).toFixed(2);
        
        $(".order-totals [data-total-price-ex-vat]").text(_.format.money(ex_vat));
        $(".order-totals [data-vat-amount]").text(_.format.money(vat));
        $(".order-totals [data-total-price-inc-vat]").text(_.format.money(total));

        //Speciality discount settings
        if(_.discounts.exist()) {
          $(".order-totals [data-discount-rate]").text(discount_percent+"%");
          $(".order-totals [data-discount-total]").text(_.format.money(discount_amount));
          $(".order-totals [data-total-price-post-discount]").text(_.format.money(ex_vat-discount_amount));
        }

        //New multipart components (Oct 2024)
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        if(j_data.hasOwnProperty("customer")) {
          var customer = j_data.customer;

          var pricepoint = _.price_points.current();
          if(pricepoint) {
            $(".order-totals [data-price-tier-title]").text(pricepoint.title);
            $(".order-totals [data-price-tier-margin]").text(pricepoint.discount_amount+"%");
            $(".order-totals [data-price-tier-mov]").text(_.format.money(pricepoint.limit_amount));
          }

          var credit_limit = parseFloat(customer.credit_limit);
          var credit_accrued = parseFloat(customer.credit_accrued);
          
          $(".order-totals [data-credit-limit]").text(_.format.money(credit_limit));
          $(".order-totals [data-credit-balance]").text(_.format.money(credit_accrued));
          $(".order-totals [data-credit-remainder]").text(_.format.money(credit_limit-credit_accrued));

        }
        __.set_validity();
        __.set_pricepoints_info();
      }
      __.refresh = function() {
        $(".order-grid").addClass("order-grid--refreshing");
        $.get(window.location.href,function(data){
          var $data = $(data);
          $(".order-grid").html($data.find(".order-grid").html());
          __.set_prices();
          $(".order-grid").removeClass("order-grid--refreshing");
          if($data.find(".order-grid .order-grid--item-grid[data-product-id]").length>0){
            //Order has items (cart.items.size!=0)
            $(".order-intro--section + .order-builder--section").removeClass("hidden");
            $(".order-intro--section").addClass("hidden");
          } else {
            //Order has no items (cart.items.size==0)
            // $(".order-intro--section").removeClass("hidden");
            // $(".order-intro--section + .order-builder--section").addClass("hidden");

            $(".order-intro--section").addClass("hidden");
            $(".order-intro--section + .order-builder--section").removeClass("hidden");
            $("#order_empty_row,#order_empty_action").removeClass("hidden");
            
          }
          _.grid.show_cart_contents();
          __.set_pricepoints_info();
        });
      }
      __.set_pricepoints_info = function() {
        // console.log("set_pricepoints_info");
        //A utility function to display various elements around the site relating to the user's currently selected pricepoint as compared to their cart's contents
        var optimal_pricepoints = _.price_points.optimal();
        var current_pricepoint = _.price_points.current();
        //RESET
        $("#tier_selector .pricepoint-selector .selector-button[data-pricepoint-id]").removeClass("optimal suggested");
        $(".order-totals--tier-suggestions").addClass("hidden");
        $(".order-totals--tier-suggestions").find("[data-non-optimal],[data-suggested]").addClass("hidden");
        $(".order-totals--tier-suggestions-2").addClass("hidden");
        $(".order-totals--tier-suggestions-2").find("[data-reduce-tier]").removeClass("hidden");
        //Check for new best/better pricepoints
        if(optimal_pricepoints.best_pricepoint||optimal_pricepoints.suggested_pricepoint){
          if(optimal_pricepoints.best_pricepoint){
            $("#tier_selector .pricepoint-selector .selector-button[data-pricepoint-id='"+optimal_pricepoints.best_pricepoint.pricepoint_id+"']").addClass("optimal");
          }
          if(optimal_pricepoints.suggested_pricepoint&&optimal_pricepoints.suggested_pricepoint.pricepoint_id!=optimal_pricepoints.best_pricepoint.pricepoint_id){
            $("#tier_selector .pricepoint-selector .selector-button[data-pricepoint-id='"+optimal_pricepoints.suggested_pricepoint.pricepoint_id+"']").addClass("suggested");
          }
          if(current_pricepoint.pricepoint_id<optimal_pricepoints.best_pricepoint.pricepoint_id||current_pricepoint.pricepoint_id<optimal_pricepoints.suggested_pricepoint.pricepoint_id) {
            $(".order-totals--tier-suggestions").removeClass("hidden");
            if(current_pricepoint.pricepoint_id<optimal_pricepoints.best_pricepoint.pricepoint_id){
              $(".order-totals--tier-suggestions [data-non-optimal]").removeClass("hidden");
            } else if(current_pricepoint.pricepoint_id<optimal_pricepoints.suggested_pricepoint.pricepoint_id) {
              $(".order-totals--tier-suggestions [data-suggested]").removeClass("hidden");
            }
          } else if(optimal_pricepoints.best_pricepoint.pricepoint_id<current_pricepoint.pricepoint_id){
            $(".order-totals--tier-suggestions-2").removeClass("hidden");
            $(".order-totals--tier-suggestions-2 [data-reduce-tier]").removeClass("hidden");
          }
        }
      }
      __.set_validity = function() {
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        if(j_data.hasOwnProperty("requirements")) {
          $("#order_requirements_minimum").text(_.format.money(j_data.requirements.amount));
          var grid_order_total = parseFloat(($(".order-totals [data-total-price-post-discount]:visible").length==1?$(".order-totals [data-total-price-post-discount]"):$(".order-totals [data-total-price-ex-vat]")).text().replace(/[£,]/g,""));
          
          // var minimum_order_requirement = parseFloat(j_data.requirements.amount); //OLD
          var minimum_order_requirement = _.price_points.minimum_order_value();
          $("#order_requirements_minimum").text(_.format.money(minimum_order_requirement));
          var credit_limit = parseFloat(j_data.customer.credit_limit);
          var credit_accrued = parseFloat(j_data.customer.credit_accrued);
          var credit_balance = credit_limit-credit_accrued;
          __.hide_all_button_options();
          
          if(credit_balance>minimum_order_requirement||grid_order_total==0){
            if(grid_order_total<credit_balance||grid_order_total==0){
              if(grid_order_total>=minimum_order_requirement||grid_order_total==0){
                //Order valid
                $("#order_button").removeClass("hidden");
                $("[data-order-validity-indicator]").addClass("order-indicator--valid");
              } else {
                //Order requirements not met
                $("#order_requirements").removeClass("hidden");
                $("[data-order-validity-indicator]").addClass("order-indicator--invalid");
              }
            } else {
              //Order amount exceeds credit limit
              $("#insufficient_credit").removeClass("hidden");
              $("[data-order-validity-indicator]").addClass("order-indicator--invalid");
            }
          } else {
            //User doesn't have credit to meet minimum order value
            if(grid_order_total<credit_balance){
              $("#mov_exceeds_credit").removeClass("hidden");
            } else {
              $("#credit_conflict").removeClass("hidden");
              $("[data-order-validity-indicator]").addClass("order-indicator--invalid");
            }
          }
        }
      }
      __.hide_all_button_options = function() {
        $("#order_requirements,#insufficient_credit,#credit_conflict,#order_button,#mov_exceeds_credit").addClass("hidden");
        $("[data-order-validity-indicator]").attr("class","");
      }
      __.set_quantity = function($element) {
        clearTimeout(__.update_timer);
        var $transfer_element = $element;
        __.update_timer = setTimeout(function(){__.update_quantity($transfer_element)},250)
      }
      __.update_quantity = function($element) {
        $(".order-grid").addClass("order-grid--refreshing");
        var $row = $element.closest(".order-grid--item-grid");

        //Find this item in the JSON and check the value inserted isn't above the max allowed cap
        console.log("Checking quantity values");
        $quantity_input = $row.find("[name='quantity']");
        if(parseInt($quantity_input.val())>parseInt($quantity_input.attr("max"))) {
          console.log("MAX THRESHOLD EXCEEDED!!!")
          $quantity_input.val($quantity_input.attr("max"));
        }

        var t_data = {
          id:$row.attr("data-item-key"),
          quantity:$row.find("[name='quantity']").val()
        };
        try {
          $.post(window.Shopify.routes.root+"cart/change.js",t_data,function(data){
            main.sidebarCart.update(false); //Call extant (external) function to refresh cart and show it
            __.refresh();
          });
        } catch (error) {
          console.error(error);
        }
      }
      __.remove_item = function($element) {
        var $item = $element.closest(".order-grid--item-background");
        $item.remove();
        $(".order-grid").addClass("order-grid--refreshing");
        var $row = $element.closest(".order-grid--item-grid");
        var t_data = {
          id:$row.attr("data-item-key"),
          quantity:0
        };
        $.post(window.Shopify.routes.root+"cart/change.js",t_data,function(data){
          main.sidebarCart.update(false); //Call extant (external) function to refresh cart and show it
          __.refresh();
        });
      }
      __.renew = function($element) {
        $("#order-placed--confirmation").addClass("hidden");
        $("#order-placer").removeClass("hidden");
      }
    }
    
    _.orders = new function() {
      var __ = this;
      __.refresh_history = function() {
        //Reloads the page and replaces the 'previous orders' tab with actual content (to include the just placed order)
        $.get(window.location.href,function(data){
          $("#history").html($(data).find("#history").html());
          $(".main-navigation [data-connect='history']").closest("li").removeClass("hidden");
        });
      }
      __.load_previous = function($element) {
        
        $("#gp-modal--contents").html("");
        $gp_form = $("<div class='gp-modal--interior--padded' />");
        $gp_form.append($("#previous_orders_picklist .order-history--picklist--wrapper").clone());
        $("#gp-modal--contents").append($gp_form);
        _.modal.launch();
      }
      __.confirm_address = function($element) {
        // $element.closest(".btn--wrapper").addClass("working");
        // $element.val("Placing order ...");

        var $modal = $("#gp-modal");

        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        var has_shipping_address = false;
        
        var $form = $("#shipping_address");
        for(var a=0;a<j_data.addresses.length;a++) {
          var address = j_data.addresses[a];
          if(typeof(address)!="undefined"&&address.address_type=='shipping') {
            if(address.address_line_1!=""&&address.postal_code!=""){
              has_shipping_address = true;
            }
          }
        }

        $("#gp-modal--contents").html("");
        
        $gp_form = $("<div class='gp-modal--interior--padded' />");
        $("#gp-modal--contents").append($gp_form);
        if(!has_shipping_address) {
          $gp_form.append("<h3>Enter your shipping address</h3>");
          $gp_form.append("<p>Please enter your shipping information before confirming your order below:</h3>");
          $form.find("[data-b2b-action='addresses.set_shipping']").text("Set shipping address and place order");
        } else {
          $gp_form.append("<h3>Confirm shipping address</h3>");
          $gp_form.append("<p>Please ensure the following information is correct before confirming your order below:</h3>");
          $form.find("[data-b2b-action='addresses.set_shipping']").text("Confirm shipping address and place order");
        }
        $("#gp-modal--contents").append($gp_form);
        $gp_form.append($form);
        _.modal.launch();
        
      }
      __.place = function($element) {

        $("#order_button").addClass("working");
        $("#order_button a").text("Placing order ...");

        //Find user's Stripe ID
        // console.log("Performing identity check");
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        var stripe_id = false;
        for(var id=0;id<j_data.identities.length;id++){
          var identity = j_data.identities[id];
          if(identity.system=="stripe") {
            stripe_id = identity.id;
          }
        }
        
        //Distil the cart into a DMA-ready Stripe invoice
        if(stripe_id) {
          var $cart = $("#cart-sidebar-wrapper");
          var user_discount = (_.discounts.exist()?_.discounts.percent():0);
          var order = { customer_id:stripe_id, user_discount: user_discount };
          var items = [];
          var has_paid_items = false;
          var has_free_items = false;
          $cart.find(".cart-contents--item").each(function(){
            var $item = $(this); //Just for naming preference
            var base_price = Math.round(parseFloat($item.attr("data-unit-base-price")),2);//Raw cost in Shopify (should be RRP)
            var tier_price = Math.round(parseFloat($item.attr("data-unit-price")),2);//Cost to current customer at selected tier
            var unit_price = tier_price;//Charged cost to customer (including global disount, if any)
            if(user_discount>0) unit_price = Math.round(unit_price*((100-user_discount)/100),2);
            var item = {
              stripe_product_id:$item.attr("data-external-id"),
              shopify_product_id:$item.attr("data-shopify-product-id"),
              shopify_variant_id:$item.attr("data-shopify-variant-id"),
              amount:Math.round(parseFloat($item.attr("data-total-price")),2),
              unit_base_price:base_price,
              tier_price:tier_price,
              unit_price:unit_price,
              unit_discount:Math.round((base_price-unit_price)*100)/100,
              description:$item.find(".cart-contents--title").text().trim(),
              quantity:$item.attr("data-line-quantity")
            }
            items.push(item);
            if(item.amount>0) { has_paid_items = true; }
            else { has_free_items = true; }
          });
          order.items = items;

          //Add a load of metadata to store the conditions applicable to the customer at the point of placing THIS order
          var current_pricepoint = _.price_points .current();
          order.pricepoint_id = current_pricepoint.pricepoint_id;
          order.pricepoint_title = current_pricepoint.title;
          order.discount_percent = (_.discounts.exist()?_.discounts.percent():0);
          order.customer_terms = j_data.customer.terms;
          order.customer_credit_limit = j_data.customer.credit_limit;
          order.customer_credit_accrued = j_data.customer.credit_accrued;
          
  
          var t_data = {};
          
          $.post(window.Shopify.routes.root+"cart/clear.js",t_data,function(data){});

          console.log("Prep data for submission");
          t_data = { invoice_data: order };
          console.log(t_data);
          
          $.post("https://accounts.togetherhealth.co.uk/w/orders/place/",t_data,function(data){
            console.log(data);
            _.modal.close();
            try {
              var j_data = JSON.parse(data);
              if(j_data.status==200) {
                // window.location.href = j_data.hosted_invoice_url;
                console.log("** END OF PROCEDURE **");
                _.order.refresh();
                __.placed.success(has_paid_items?"paid":"free");
              } else {
                __.placed.failure();
              }
            } catch (error) {
              //Add log here, before passing to failure sub
              var customer_id = $("#info").attr("data-customer-id");
              t_data = {customer_id:customer_id,log:data};
              $.post("https://accounts.togetherhealth.co.uk/w/orders/"+customer_id+"/trap/",t_data,function(data){});
              console.error(error);
              __.placed.failure();
            }
          });
        } else {
          console.log("Stripe ID not found");
        }
      }
      __.placed = new function() {
        var ___ = this;
        ___.success = function(order_type) {
          //Get to refreshing the previous orders page
          __.refresh_history();
          $("#order-placer").addClass("hidden");
          $("#order-placed--confirmation").removeClass("hidden");
          $("body,html").animate({"scrollTop":$("#top-of-confirmation").offset().top-200},150);
          var $modal = $("#gp-modal");
          var j_data = JSON.parse(window.sessionStorage.b2b_info);
          $("#gp-modal--contents").html($("#order_success").text());
          if(order_type=="paid"){
            $("#gp-modal--contents [data-terms]").text(j_data.customer.terms);
          } else {
            $("#gp-modal--contents .paid-only").remove();
          }
          _.modal.launch();
          $("#order_button").removeClass("working");
          $("#order_button a").text("Place order");
        }
        ___.failure = function() {
          var $modal = $("#gp-modal");
          $("#gp-modal--contents").html($("#order_failure").text());
          _.modal.launch();
          $("#order_button").removeClass("working");
          $("#order_button a").text("Place order");
        }
      }
      __.history = new function () {
        var ___ = this;
        ___.init = function() {
          var j_data = JSON.parse(window.sessionStorage.b2b_info);
          if(j_data.hasOwnProperty("orders")) {
            //Loop through available orders and add tags or options as approriate
            for(var o=0;o<j_data.orders.length;o++) {
              var order = j_data.orders[o];
              if(order.hasOwnProperty("shopify_order_id")&&order.shopify_order_id!="") {
                var $order = $(".order-history--item[data-order-id='"+order.shopify_order_id+"']");
                if($order.length==1){
                  if(!order.date_charged) {
                    $order.find(".order-history--payment-status").removeClass("hidden");
                    $order.find(".order-history--tag--status").text("Due "+_.format.date.shortRevT(order.date_payment_due));
                  }
                }
              }
            }
          }
          
        }
        ___.tally = function() {
          //Creates a new array from input order_history arranged by date
          var j_data = JSON.parse(window.sessionStorage.b2b_info);
          var refactor = {items:[]};
          var extant, item;
          for(var i=0;i<j_data.items.length;i++) {
            item = j_data.items[i];
            // refactor.items.push({product_id:previous_order.product_id,orders:[{date:previous_order.date,quantity:previous_order.quantity}]});
          }
          if(order_history&&order_history.length>0) {
            for(var h=0;h<order_history.length;h++) {
              extant = false;
              previous_order = order_history[h];
              
              for(var i=0;i<refactor.items.length;i++) {
                item = refactor.items[i];
                if(item.product_id==previous_order.product_id) {
                  item.orders.push({date:previous_order.date,quantity:previous_order.quantity});
                  extant = true;
                }
              }
              if(!extant) {
                //If it doesn't exist in the array already, it isn't wanted
                // refactor.items.push({product_id:previous_order.product_id,orders:[{date:previous_order.date,quantity:previous_order.quantity}]});
              }
            }
          }
          console.log(refactor);
        }
      }

      __.prepreload = function(){
        //If the DMA response object has property customer.default_order, the order can be parsed and loaded into the customer's account
        //Prepre will clear the cart if contents already exist
        var cart_contents = $("#shopify-section-cart-sidebar .cart-contents--item").length;
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        var customer = j_data.customer;
        if(customer.hasOwnProperty("default_order")&&customer.default_order) {
          var t_data = {};
          if(cart_contents>0) {
            console.log("Cart nears clearing first");
            $.post(window.Shopify.routes.root+"cart/clear.js",t_data,function(data){__.preload();});
          } else {
            __.preload();
          }
        }
      }
      __.preload = function(){
        //Load cart
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        var customer = j_data.customer;
        if(customer.hasOwnProperty("default_order")) {
          var package = customer.default_order;
          var items = [];
          for(i=0;i<package.length;i++){
            var item = {
              id:_.product.variant_id(parseInt(package[i].id)),
              quantity:parseInt(package[i].quantity)
            }
            items.push(item);
          }
          if(items.length>0) {
            var t_data = {items:items};
            console.log(t_data);
            console.log(JSON.stringify(t_data));
            $.post(window.Shopify.routes.root+"cart/add.js",t_data,function(data){
              console.log(data);
              _.order.refresh();
              _.modal.close();
              $("body,html").animate({"scrollTop":$("#top-of-order").offset().top-200},150);
              //Send a quiet dma call to clear the default_order
              __.clear_default();
            });
          } else {
            _.modal.close();
          }
        }
      }
      __.clear_default = function() {
        const customer_id = $("#customer_id").val();
        const url = "https://accounts.togetherhealth.co.uk/w/accounts/"+customer_id+"/clearDefaultOrder/?v=";
        if(customer_id!="") {
          $.get(url,function(data) {
              //Nothing to do here, data will update timely on next load
              console.log("DELETE finished");
          });
        }
      }
    }

    _.product = new function() {
      var __ = this;
      __.pricepoint_price = function(product,pricepoint_id) {
        //Product is an element from the item array on the customer's b2b object
        var result = 0;
        if(product.hasOwnProperty("price_points")&&product.price_points!=null) {
          for(p=0;p<product.price_points.length;p++) {
            var pricepoint = product.price_points[p];
            if(pricepoint.pricepoint_id==pricepoint_id) result = parseFloat(pricepoint.discount_price_ex_vat);
          }
        }
        return result;
      }
      __.variant_id = function(product_id){
        var variant_id = false;
        for(p=0;p<global_products.products.length;p++){
          var product = global_products.products[p];
          if(product.product_id==product_id) variant_id = product.variant_id;
        }
        return variant_id;
      }
    }

    _.marketing = new function() {
      var __ = this;
      __.init = function() {
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        //Loop through available products and set marketing options
        for(var i=0;i<j_data.items.length;i++) {
          var item = j_data.items[i];
          if(item.type=="other"){
            //Check for limiter properties
            if(item.hasOwnProperty("limit_amount")) {
              //Find shopify id
              for(var id=0;id<item.identities.length;id++) {
                var identity = item.identities[id];
                if(identity.system=="shopify") {
                  var $marketing_block = $(".marketing-block--item[data-product-id='"+identity.id+"']");
                  if($marketing_block.length>0){
                    $marketing_block.find("[data-limit-quantity]").text(item.limit_quantity);
                    $marketing_block.find("[data-limit-amount]").text(item.limit_amount);
                    $marketing_block.find("[data-limit-unit]").text(item.limit_unit);
                    $marketing_block.attr("data-limited",true);
                    //Have all been ordered in period?
                    if(item.limit_quantity_ordered>=parseInt(item.limit_quantity)){
                      //Remove purchase form and display limited message
                      $marketing_block.find(".marketing-item--form-actions,.marketing-item--limited").remove();
                    } else {
                      //Remove the limit reached message
                      $marketing_block.find(".marketing-item--limit-reached .marketing-orders--capacity").remove();
                      //Constrict the quantity selector
                      var limit_allowed = parseInt(item.limit_quantity)-item.limit_quantity_ordered;
                      if(limit_allowed<10){
                        $marketing_block.find("[name='quantity'] option").each(function(){
                          if($(this).val()>limit_allowed) $(this).remove();
                        });
                      }
                    }
                  }
                }
              }
            }
          }
        }
        //Remove limit information from unlimited items
        $(".marketing-block--item:not([data-limited])").find(".marketing-item--limit-reached,.marketing-item--limited").remove();
        //Show all marketing forms now they have been processed / populated
        $(".marketing-item--order-form").removeClass("hidden");
      }
      __.add_to_order = function($element) {
        $element.addClass("working");
        var items = [];
        var $order_form = $element.closest(".marketing-item--order-form");

        var quantity = $order_form.find("[name='quantity']").val();
        if(quantity>0){
          var item = {id:$element.attr("data-variant-id"),quantity:quantity}
          items.push(item);
        }
        if(items.length>0) {
          var t_data = {items:items};
          console.log(t_data);
          $.post(window.Shopify.routes.root+"cart/add.js",t_data,function(data){
            console.log(data);
            main.sidebarCart.update(false); //Call extant (external) function to refresh cart but don't show it
            $element.removeClass("working");
            _.order.refresh();
          });
        }
        
      }
    }

    _.discounts = new function() {
      var __ = this;
      __.init = function() {
        console.log("discounts.init");
        if(__.exist()) {
          $("[data-add-discount-indicator-class]").addClass("has-discount");
        } else {
          $("[data-add-discount-indicator-class]").addClass("no-discount");
        }
      }
      __.exist = function() {
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        var response = false;
        if(j_data.hasOwnProperty("discounts")&&j_data.discounts.length>0) {
          response = true;
        }
        return response;
      }
      __.percent = function() {
        var response = 0;
        if(__.exist()) {
          var j_data = JSON.parse(window.sessionStorage.b2b_info);
          response = parseFloat(j_data.discounts[0].amount);
        }
        return response;
      }
      
    }

    _.mandate = new function() {
      var __ = this;
      __.begin = function($element) {
        //MOVED TO DIRECT COMPLETION ON STRIPE CHECKOUT DUE TO ONGOING ISSUES WITH MANDATE PROCESSING ON STRIPE SIDE
        var j_data = JSON.parse(window.sessionStorage.b2b_info);
        if(j_data.identities.length>1) {
          var stripe_id = false;
          for(var id=0;id<j_data.identities.length;id++){
            var identity = j_data.identities[id];
            if(identity.system=="stripe") {
              stripe_id = identity.id;
            }
          }
          if(stripe_id) {
            $element.addClass("working");
            console.log("stripe_id: "+stripe_id);
            // window.location.href = "https://accounts.togetherhealth.co.uk/w/checkout/"+stripe_id+"/session/";
            $.get("https://accounts.togetherhealth.co.uk/w/checkout/"+stripe_id+"/session/",function(data){
              console.log(data);
              var rj_data = JSON.parse(data);
              if(rj_data.hasOwnProperty("url")) {
                window.location.href = rj_data.url;
              }
            });
          }
        }
        // var $form = $("#mandate_form");
        // $("#mandate_form_introduction").addClass("hidden");
        // $("#mandate_form_details").removeClass("hidden");
        // $("#mandate_form_confirmation").addClass("hidden");
      }
      __.continue = function($element) {
        var $form = $("#mandate_form");
        if(__.validate($form)) {
          //Carry data to confirmation step
          $("#mandate_form_confirmation #mandate_email").text($form.find("[name='email']").val());
          $("#mandate_form_confirmation #mandate_email_2").text($form.find("[name='email']").val());
          $("#mandate_form_confirmation #mandate_name").text($form.find("[name='account_name']").val());
          $("#mandate_form_confirmation #mandate_sort_code").text($form.find("[name='sort_code']").val());
          $("#mandate_form_confirmation #mandate_account_no").text($form.find("[name='account_no']").val());
          $("#mandate_form_details").addClass("hidden");
          $("#mandate_form_confirmation").removeClass("hidden");
        }
      }
      __.validate = function($form) {
        var required_fields = ["account_no","sort_code","account_name","address_1","city","postcode","county","confirmation"];
        var form_valid = true;
        $form.find("input").each(function(){
          var $field = $(this);
          if(required_fields.indexOf($field.attr("name"))>-1){
            if($field.attr("type")=="checkbox"&&!$field.is(":checked")) {
              form_valid = false;
              console.log("Field "+$field.attr("name")+" has a problem");
              $field.closest("span").addClass("mandate--error");
            } else if($field.val().trim()==""){
              form_valid = false;
              console.log("Field "+$field.attr("name")+" has a problem");
              $field.closest("span").addClass("mandate--error");
            }
          }
        });
        if(form_valid){console.log("No issues to report!")}
        return form_valid;
      }
      __.previous = function($element) {
        $("#mandate_form_details").removeClass("hidden");
        $("#mandate_form_confirmation").addClass("hidden");
      }
      __.confirm = function($element) {
        var $form = $("#mandate_form");
        if(__.validate($form)) {
          //Carry data to confirmation step
          var j_data = JSON.parse(window.sessionStorage.b2b_info);
          if(j_data.identities.length>1) {
            var stripe_id = false;
            for(var id=0;id<j_data.identities.length;id++){
              var identity = j_data.identities[id];
              if(identity.system=="stripe") {
                stripe_id = identity.id;
              }
            }
            if(stripe_id) {
              $("#mandate_form_details").addClass("hidden");
              $("#mandate_form_confirmation").addClass("hidden");
              $("#mandate_form_submission").removeClass("hidden");
              var t_data = {
                customer_id:stripe_id,
                email:$form.find("[name='email']").val(),
                account_name:$form.find("[name='account_name']").val(),
                sort_code:$form.find("[name='sort_code']").val(),
                account_no:$form.find("[name='account_no']").val(),
                address_line_1:$form.find("[name='address_1']").val(),
                address_line_2:$form.find("[name='address_2']").val(),
                city:$form.find("[name='city']").val(),
                postcode:$form.find("[name='postcode']").val(),
                county:$form.find("[name='county']").val()
              }
              console.log(t_data);

              $.post("https://accounts.togetherhealth.co.uk/apps/wholesale/mandates/"+stripe_id+"/create/",t_data,function(data){
                console.log(data);
                $("#mandate_form_submission").addClass("hidden");
                $("#mandate_form_success").removeClass("hidden");
              });
              
            }
          }
        }
      }
      __.open_modal = function($element) {
        $("#mandate_modal").removeClass("hidden");
      }
      __.close_modal = function($element) {
        $("#mandate_modal").addClass("hidden");
      }
    }

    _.contact_details = new function() {
      var __ = this;
      __.save_changes = function($element) {
        $("#contact_info").addClass("refreshing");
        var customer_id = $("#customer_id").val();

        var $source = $element.closest("[data-source]");
        var contact = {
          address_type:$source.attr("data-source").split(":")[1]
        };
        $source.find("input").each(function(){
          contact[$(this).attr("name")] = $(this).val()
        });
        console.log(contact);
        $element.addClass("working");
        console.log("https://accounts.togetherhealth.co.uk/w/addresses/"+customer_id+"/updateRemote/");
        $.post("https://accounts.togetherhealth.co.uk/w/addresses/"+customer_id+"/updateRemote/",contact,function(data){
          console.log(data);
          var j_data = JSON.parse(data);
          if(j_data.hasOwnProperty("status")&&j_data.status=="200") {
            __.save_success($element);
          } else {
            if(j_data.hasOwnProperty("message")) console.log(j_data.message);
            __.save_failed($element);
          }
        });
        
      }
      __.save_success = function($element) {
        var $address_block = $element.closest("[data-source]");

        //Save changes to hash
        const address_type = $address_block.attr("data-source").split(":")[1];
        _.customer.address_hashes[address_type] = _.addresses.hash(address_type);
        
        $("#contact_info").removeClass("refreshing");
        $element.removeClass("working");
        $address_block.find("[data-action-prompt]").addClass("hidden");
        $address_block.find("[data-action-response-positive]").removeClass("hidden");
      }
      __.save_failed = function($element) {
        var $address_block = $element.closest("[data-source]");
        $("#contact_info").removeClass("refreshing");
        $element.removeClass("working");
        $address_block.find("[data-action-prompt]").addClass("hidden");
        $address_block.find("[data-action-response-negative]").removeClass("hidden");
      }
    }

    
    _.modal = new function() {
      var __ = this;
      __.launch = function($element) {
        $("#gp_modal .gp-modal--window").removeClass("gp-modal--window--wide gp-modal--window--padded")
        $("#gp_modal").removeClass("hidden");
      }
      __.close = function($element) {
        //Check if the price tier selector is in the modal and, if so, return it to page placeholder
        if($("#gp_modal #tier_selector").length>0) {
          $("#pricing-intro").addClass("hidden");
          $("#gp_modal .modal-actions").remove();
          $("#pricing-tiers").append($("#gp-modal--contents").children());
        }
        //Check if shipping address is in modal and return if needed
        if($("#gp_modal #shipping_address").length>0) {
          var $form = $("#shipping_address");
          //Put the form back in storage (auto-includes any user updates)
          $("#shipping_address_placer").append($form);
        }
        
        $("#gp_modal .gp-modal--window").removeClass("gp-modal--window--wide gp-modal--window--padded")
        $("#gp_modal").addClass("hidden");
      }
    }
    

    _.data = new function() {
      var __ = this;
      __.validate = function(callback) {
          __.fetch(callback);
        // if(!window.sessionStorage.b2b_info) {
        //   __.fetch(callback);
        // } else {
        //   _.callback(callback);
        // }
      }
      __.fetch = function(callback) {
        console.log("** DATA FETCH **");
        var customer_id = $("#customer_id").val();
        console.log("https://accounts.togetherhealth.co.uk/w/accounts/"+customer_id+"/?v=");
        if(customer_id!="") {
          $.get("https://accounts.togetherhealth.co.uk/w/accounts/"+customer_id+"/?v="+Math.round(Math.random()*10000),function(data){
            var j_data = JSON.parse(data);
            if(j_data.identities.length>1) {
              if(j_data.customer.status==1) __.store(data); //Only save data locally if it is complete
              _.callback(callback);
            } else {
              _.init_no_data();
            }
          });
        } else {
          _.init_no_data();
        }
      }
      __.store = function(data) {
        sessionStorage.setItem('b2b_info',data);
      }
    }

    _.tab = new function() {
      var __ = this;
      __.go_to_order = function($element) {
        $("[data-tab]").addClass("hidden");
        $("#order").removeClass("hidden");
        $(".main-navigation .active").removeClass("active");
        $(".main-navigation [data-connect='order']").addClass("active");
        history.pushState(null, document.title, "/account?tab=order");
      }
    }

    _.callback = function(callback_function,callback_input = undefined) {
      //A quick class to handle dot notation in callback operations (or not!)
      var callback_parts = callback_function.split(".");
      if(callback_parts.length==1){
        _[callback_parts[0]](callback_input);
      } else if(callback_parts.length==2){
        _[callback_parts[0]][callback_parts[1]](callback_input);
      }
    }

    _.b2b_action = new function() {
      var __ = this;
      __.scroll_to = function($element) {
        console.log("scroll_to");
        console.log($element.attr("data-target"));
        var $target = $("#"+$element.attr("data-target"));
        if($target.length>0){
          console.log("Scroll to top!");
          console.log($target.offset().top);
          $("window,html").animate({"scrollTop":($target.offset().top-180)+"px"});
        } else {
          console.log("Target does not exist");
        }
      }
    }


    _.format = new function() {
      var __ = this;
      __.date = new function() {
        var ___ = this;
  
        ___.sensible = function(datetimestring) {
          if(datetimestring.indexOf("/")>-1) {
            var date_parts = datetimestring.split("/");
            datetimestring = date_parts[2]+"-"+date_parts[1]+"-"+date_parts[0];
          }
          const date = new Date(datetimestring);
          const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'long', day: '2-digit' }) 
          const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat.formatToParts(date);
          return `${day} ${month} ${year }`;
        }
        ___.short = function(datetimestring) {
          const date = new Date(datetimestring);
          const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: 'numeric' });
          const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat.formatToParts(date);
          var final = `${month} ${day}`;
          if(final.substr(final.length-2,1)!="1") {
            switch(final.substr(final.length-1,1)) {
              case "1":
                final += "st";
                break;
              case "2":
                final += "nd";
                break;
              case "3":
                final += "rd";
                break;
              default:
                final += "th";
                break;
            }
          } else {
            final += "th";
          }
          return final;
        }
        ___.shortRev = function(datetimestring) {
          const date = new Date(datetimestring);
          const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'long', day: 'numeric' });
          const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat.formatToParts(date);
          var final = `${month} ${day}`;
          if(final.substr(final.length-2,1)!="1") {
            switch(final.substr(final.length-1,1)) {
              case "1":
                final += "st";
                break;
              case "2":
                final += "nd";
                break;
              case "3":
                final += "rd";
                break;
              default:
                final += "th";
                break;
            }
          } else {
            final += "th";
          }
          final = final.split(" ");
          return final[1]+" "+final[0];
        }
        ___.shortRevT = function(datetimestring) {
          const date = new Date(datetimestring);
          const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: 'numeric' });
          const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat.formatToParts(date);
          var final = `${month} ${day}`;
          if(final.substr(final.length-2,1)!="1") {
            switch(final.substr(final.length-1,1)) {
              case "1":
                final += "st";
                break;
              case "2":
                final += "nd";
                break;
              case "3":
                final += "rd";
                break;
              default:
                final += "th";
                break;
            }
          } else {
            final += "th";
          }
          final = final.split(" ");
          return final[1]+" "+final[0];
        }
        ___.verbose = function(datetimestring) {
          const date = new Date(datetimestring);
          const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'long', day: 'numeric', weekday: 'short' });
          const [{ value: weekday },,{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat.formatToParts(date);
          var final = `${weekday}, ${day}`;
          if(final.substr(final.length-2,1)!="1") {
            switch(final.substr(final.length-1,1)) {
              case "1":
                final += "st";
                break;
              case "2":
                final += "nd";
                break;
              case "3":
                final += "rd";
                break;
              default:
                final += "th";
                break;
            }
          } else {
            final += "th";
          }
          final += ` ${month}`;
          return final;
        }
        ___.yearless = function(datetimestring) {
          const date = new Date(datetimestring);
          const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'long', day: 'numeric', weekday: 'short' });
          const [{ value: weekday },,{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat.formatToParts(date);
          var final = `${day}`;
          if(final.substr(final.length-2,1)!="1") {
            switch(final.substr(final.length-1,1)) {
              case "1":
                final += "st";
                break;
              case "2":
                final += "nd";
                break;
              case "3":
                final += "rd";
                break;
              default:
                final += "th";
                break;
            }
          } else {
            final += "th";
          }
          final += ` ${month}`;
          return final;
        }
        
      }
      __.money = function(moneydecimal){
				return "£"+(moneydecimal==""?"0":parseFloat(moneydecimal).toFixed(2).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","));
      }
    }

    _.hashCode = function(str) {
      if (str.length % 32 > 0) str += Array(33 - str.length % 32).join("z");
      var i, j, k, a; i = j = k = a = 0;
      var hash = '';
      var bytes = [];
      var dict = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','1','2','3','4','5','6','7','8','9'];
      for (i = 0; i < str.length; i++ ) {
          ch = str.charCodeAt(i);
          bytes[j++] = (ch < 127) ? ch & 0xFF : 127;
      }
      var chunk_len = Math.ceil(bytes.length / 32);   
      for (i=0; i<bytes.length; i++) {
          j += bytes[i];
          k++;
          if ((k == chunk_len) || (i == bytes.length-1)) {
              a = Math.floor( j / k );
              if (a < 32)
                  hash += '0';
              else if (a > 126)
                  hash += 'z';
              else
                  hash += dict[  Math.floor( (a-32) / 2.76) ];
              j = k = 0;
          }
      }
      return hash;
    }

    //System level operations
    _.acknowledge = function(message) {
      console.log(message + " [from " + _.class + " func]");
    }
  }

  $(function(){ b2b.init(); });

})(jQuery);


window.addEventListener("popstate", (e) => {
  console.log("back");
  if(e.state){
    console.log("stated");
    // document.getElementById("content").innerHTML = e.state.html;
    // document.title = e.state.pageTitle;
  } else {
    const urlParams = new URLSearchParams(window.location.search);
    const tab_target = urlParams.get('tab');
    console.log(tab_target);
    if(tab_target){
      account_main.account_action.open_tab(undefined,tab_target);
      // $(".main-navigation [data-connect='"+tab_target+"']").trigger("click");
    }
  }
  
});
